// import { createRouter, createWebHistory} from 'vue-router';

// import { authGuard } from '@/_helpers';

// const routes = [
//     { path: '/', beforeEnter: authGuard },
//     { path: '/:pathMatch(.*)*', redirect: '/' }
// ];

// export const router = createRouter({
//     history: createWebHistory(),
//     routes
// });

import { accountService } from '@/_services';
import { router } from '@/_helpers';

export function authGuard(to) {
    const account = accountService.accountValue;
    if (account) {
        // logged in so return true
        return true;
    }

    // not logged in so redirect to login page with the return url
    router.push({ path: '/login'});
    return false;
}